/**
 * @generated SignedSource<<f1caab92aea174abf6b6ef762d1deb14>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserRelationshipTypes_query$data = {
  readonly currentUser: {
    readonly userRelationshipTypes: {
      readonly nodes: ReadonlyArray<{
        readonly relationshipTypeId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useUserRelationshipTypes_query";
};
export type useUserRelationshipTypes_query$key = {
  readonly " $data"?: useUserRelationshipTypes_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUserRelationshipTypes_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useUserRelationshipTypes_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "UserRelationshipTypeConnection",
          "kind": "LinkedField",
          "name": "userRelationshipTypes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserRelationshipType",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "relationshipTypeId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "userRelationshipTypes(orderBy:[\"RELATIONSHIP_TYPE_BY_RELATIONSHIP_TYPE_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "241e3e396171c966f287f12bd19ae52d";

export default node;
